import { Trans, useLingui } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconPackage from '@/icons/Package.svg';

export const ArticleSelfHandledTransitStartedActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'article_self_handled_transit_started'>;
  displayArticleName: boolean;
}) => {
  const { t } = useLingui();
  const creatorName = activity.creator?.name;
  const articleName = (
    <BaseActivityArticleName activity={activity} displayArticleName={displayArticleName} />
  );
  const trackingNumber = activity.data.trackingNumber;
  const trackingNumberLabel = trackingNumber
    ? `. ${t({
        id: 'activities.article_self_handled_transit_started.tracking_number',
        message: `Tracking number: ${trackingNumber}`,
      })}`
    : '';

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="primary"
      icon={<IconPackage />}
      message={
        <>
          <BaseActivityText>
            {displayArticleName ? (
              <Trans id="activities.article_self_handled_transit_started.message-item">
                <strong>{creatorName}</strong> confirmed package handling for the item {articleName}
                {trackingNumberLabel}
              </Trans>
            ) : (
              <Trans id="activities.article_self_handled_transit_started.message">
                <strong>{creatorName}</strong> confirmed package handling {trackingNumberLabel}
              </Trans>
            )}
          </BaseActivityText>
        </>
      }
    />
  );
};
